import type { EnemyDef } from '../../types';
import type { Enemy } from './Enemy';
import { Onion } from './Onion';
import { Pepper } from './Pepper';

export { Enemy } from './Enemy';
export type { EnemyContext } from './Enemy';
export { Onion } from './Onion';
export { Pepper } from './Pepper';

export function createEnemy(def: EnemyDef): Enemy {
  switch (def.type) {
    case 'onion':
      return new Onion(def);
    case 'pepper':
      return new Pepper(def);
  }
}
